import React from 'react'
const Footer = () => {
  return (
    <>
    <footer>
      
    <div >
        <h1>CodeStar</h1>
        <p>@all right reserverd</p>
    </div>
    <div>
        <h5>Follow us</h5>
        <div>
            <a href="">Facebook</a>
            <a href="">YouTube</a>
            <a href="">Instagram</a>
            <a href="">@E-Mail</a>
        </div>
    </div>
    
    </footer>
    </>
  )
}

export default Footer